module.exports = __webpack_public_path__ + "img/stock0.fe1b6ed8.png";